import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { DeviceTask } from '@era/device-task-management-sdk';
import { DeviceScheduledTasksCancelComponent } from './device-scheduled-tasks-cancel.component';
import { DeviceScheduledTasksStoreActions } from '../../sub-features/device-sync/device-scheduled-tasks-store';

@Component({
  selector: 'era-device-scheduled-tasks-cancel',
  templateUrl: './device-scheduled-tasks-cancel.container.html',
  styleUrls: ['./device-scheduled-tasks-cancel.container.scss'],
  imports: [DeviceScheduledTasksCancelComponent],
})
export class DeviceScheduledTasksCancelContainerComponent {
  constructor(private readonly deviceTaskStore: Store<DeviceTask>) {}

  public cancel() {
    this.deviceTaskStore.dispatch(
      DeviceScheduledTasksStoreActions.DeviceScheduledTasksUiActions.scheduledTasksDeleted()
    );
  }
}
